export default __webpack_public_path__ + "static/media/SEC1390.34I-32565_-17851_0.7e3dd27e.jpg";